import { Tooltip, theme } from 'antd'
import { PropsWithChildren, ReactNode, useMemo } from 'react'
import { useSelector } from 'react-redux'

import './index.scss'
import { getDeferredConfig } from 'src/app/store/masterSetup'

const { useToken } = theme

export const PasswordTooltip: React.FC<
  PropsWithChildren<{
    children?: ReactNode
  }>
> = (props) => {
  const { children } = props
  const { token } = useToken()
  const deferredConfig = useSelector(getDeferredConfig)
  const tooltipStyle = {
    borderRadius: token.borderRadius,
    color: token.colorText,
  }
  const overlayStyle = {
    maxWidth: '500px',
  }
  const PasswordTooltipCard = useMemo(() => {
    return (
      <div className='password__tooltip' style={tooltipStyle}>
        <div className='password__tooltip__title'>Password must follow the following rules:</div>
        <ul style={{ listStyle: 'inside', fontSize: '14px', paddingLeft: '10px' }}>
          <li>Password must be at least {deferredConfig?.systemSettings?.passwordMinimumLength} characters long</li>
          <li>Password cannot be longer than 128 characters</li>
          <li>It should contain at least one lowercase letter</li>
          <li>It should contain at least one uppercase letter</li>
          <li>It should contain at least one number</li>
          <li>It should contain at least one special character limited to !, @, #, $, %, ^, &, *, {`)`}</li>
        </ul>
      </div>
    )
  }, [tooltipStyle])

  return (
    <Tooltip placement='left' title={PasswordTooltipCard} color='white' overlayStyle={overlayStyle} arrow={false}>
      {children}
    </Tooltip>
  )
}
